const BASE_STATUS_GROUPS = {
  upcoming: ["Order Placed"],
  active: [
    "In Warehouse",
    "Departure at Origin",
    "In Transit",
    "Arrival at Destination",
    "Notification",
    "Custom Clearance",
  ],
  total: [
    "Order Placed",
    "In Warehouse",
    "Departure at Origin",
    "In Transit",
    "Arrival at Destination",
    "Notification",
    "Custom Clearance",
    "Delivered",
    "Turnover",
  ],
  completed: ["Delivered", "Turnover"],
  cancelled: ["Cancelled"],
};

export const isShipmentBilled = (shipment) => Boolean(shipment?.is_billed);
export const isShipmentPaid = (shipment) => Boolean(shipment?.is_paid);

export const getShipmentStatusGroups = ({ includeTurnover = false } = {}) => {
  if (!includeTurnover) {
    return BASE_STATUS_GROUPS;
  }

  return BASE_STATUS_GROUPS;
};

export const matchesShipmentStatusFilter = (
  shipment,
  statusFilter,
  { includeTurnover = false } = {}
) => {
  if (!statusFilter) {
    return true;
  }

  const normalizedFilter = String(statusFilter).toLowerCase();

  if (normalizedFilter === "billed") {
    return isShipmentBilled(shipment);
  }

  const statusGroups = getShipmentStatusGroups({ includeTurnover });

  return statusGroups[normalizedFilter]?.includes(shipment?.status) ?? false;
};

export const getShipmentStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "order placed":
      return "bg-blue/10 text-blue border border-blue/30";
    case "in warehouse":
      return "bg-yellow/10 text-yellow border border-yellow/30";
    case "departure at origin":
      return "bg-purple-100 text-purple-700 border border-purple-300";
    case "in transit":
      return "bg-orange-100 text-orange-700 border border-orange-300";
    case "arrival at destination":
      return "bg-green-100 text-green-700 border border-green-300";
    case "custom clearance":
      return "bg-indigo-100 text-indigo-700 border border-indigo-300";
    case "delivered":
      return "bg-green-100 text-green-800 border border-green-300";
    case "turnover":
      return "bg-emerald-100 text-emerald-700 border border-emerald-300";
    case "cancelled":
      return "bg-red-100 text-red-700 border border-red-300";
    default:
      return "bg-gray-100 text-gray-700 border border-gray-300";
  }
};

export const getBillingStatusLabel = (isBilled) =>
  isBilled ? "Billed" : "Not Billed";

export const getBillingStatusColor = (isBilled) =>
  isBilled
    ? "bg-green-100 text-green-700 border border-green-300"
    : "bg-gray-100 text-gray-600 border border-gray-300";

export const getPaymentStatusLabel = (isPaid) => (isPaid ? "Paid" : "Unpaid");

export const getPaymentStatusColor = (isPaid) =>
  isPaid
    ? "bg-green-100 text-green-700 border border-green-300"
    : "bg-amber-100 text-amber-700 border border-amber-300";
